import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a120b] text-[#f6efe1] pt-20 pb-10 mt-24 relative overflow-hidden">
      <div className="container-lux relative z-10">
        <div className="py-16">
          <div className="md:max-w-2xl mb-14">
            <img src="/logo-wordmark.png" alt="Raretto" className="h-9 w-auto invert mb-6" />
            <p className="tracking-luxe text-[#b78d3c] mb-3 text-xs">About Us</p>
            <p className="text-[#f6efe1]/75 leading-relaxed">
              Founded in <strong className="text-[#f6efe1]">1968</strong>,{' '}
              <strong className="text-[#f6efe1]">Rajasthan Trading Co.</strong>{' '}
              has a long-standing legacy in crafting authentic Indian sweets,
              beginning with the timeless classic{' '}
              <em className="not-italic font-serif-alt">Kaju Katli</em>. With
              decades of expertise and a passion for innovation, we evolved to
              embrace the modern love for chocolate.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
            
            <div>
              <p className="tracking-luxe text-[#b78d3c] mb-5">Explore</p>
              <ul className="space-y-3">
                <li><Link to="/crunch" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">The Crunch</Link></li>
                <li><Link to="/barks" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">The Barks</Link></li>
                <li><Link to="/build-a-box" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Curate a Box</Link></li>
                <li><Link to="/shop" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Shop</Link></li>
                <li><Link to="/track-order" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Track Order</Link></li>
              </ul>
            </div>
            <div>
              <p className="tracking-luxe text-[#b78d3c] mb-5">The House</p>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Our Story</Link></li>
                <li><Link to="/about" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">The Founder</Link></li>
                <li><Link to="/about" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Sourcing</Link></li>
                
              </ul>
            </div>
            <div>
              <p className="tracking-luxe text-[#b78d3c] mb-5">Policies</p>
              <ul className="space-y-3">
                <li><Link to="/shipping-policy" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Shipping Policy</Link></li>
                <li><Link to="/refund-and-returns-policy" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Refund & Returns</Link></li>
                <li><Link to="/terms-conditions" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Terms & Conditions</Link></li>
                <li><Link to="/privacy-policy" className="text-[#f6efe1]/80 hover:text-[#f6efe1]">Privacy Policy</Link></li>
              </ul>
            </div>
            <div className="space-y-3 text-sm">
              <p className="tracking-luxe text-[#b78d3c] mb-5">Contact</p>
              {/* <p className="flex items-start gap-3 text-[#f6efe1]/80">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#b78d3c]" />
                Worli, Mumbai, Maharashtra, 400018
              </p> */}
              <p className="flex items-center gap-3 text-[#f6efe1]/80">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#b78d3c]" />
                <a href="mailto:customersupport@raretto.com" className="hover:text-[#f6efe1]">
                  customersupport@raretto.com
                </a>
              </p>
              <p className="flex items-center gap-3 text-[#f6efe1]/80">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#b78d3c]" />
                <a href="tel:+919167798999" className="hover:text-[#f6efe1]">
                  +91 91677 98999
                </a>
              </p>
              <a
                href="https://www.instagram.com/raretto_chocolates/"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 text-[#f6efe1]/80 hover:text-[#f6efe1] transition-colors"
              >
                <Instagram className="w-4 h-4 flex-shrink-0 text-[#b78d3c]" />
                raretto_chocolates
              </a>
            </div>
          </div>
        </div>

        <div className="gold-rule"></div>
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-[#f6efe1]/50 text-xs tracking-widest">© {new Date().getFullYear()} PURE PLUCKS LLP</p>
          <p className="text-[#f6efe1]/40 text-xs tracking-widest italic font-serif-alt">A rare pleasure, quietly held.</p>
        </div>
      </div>

      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[#b78d3c]/8 blur-3xl pointer-events-none"></div>
    </footer>
  );
};

export default Footer;
